export default "__VITE_ASSET__dcb7314d__"